export interface IGrade {
  id: string
  name: string
  sequence: number
  cycleId: string
  cycleName: string
}
